import { Box, Grid, Hidden, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { SkeletonLoadingConfig } from '../global/globalSettings';
import { GenCurrency, GenDate } from './GenDataFormat';

const PREFIX = 'GenDataText';

const classes = {
  textBox: `${PREFIX}-textBox`,
  textBoxVertical: `${PREFIX}-textBoxVertical`,
  vertical: `${PREFIX}-vertical`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.textBox}`]: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(0),
    },
  },

  [`& .${classes.textBoxVertical}`]: {
    marginLeft: theme.spacing(0),
  },

  [`& .${classes.vertical}`]: {
    flexDirection: 'column',
  },
}));

const GenDataText = ({
  label,
  text,
  direction = 'horizontal',
  date = false,
  labelVariant = 'subtitle2',
  labelColor = 'textPrimary',
  textVariant = 'body2',
  textColor = 'textSecondary',
  alignItems = 'center',
  currency = false,
  textboxParams,
  noTime = false,
  sx,
  ...props
}) => {
  const [textElement, setTextElement] = useState(null);

  useEffect(() => {
    if (!text && text !== 0) {
      setTextElement(<Skeleton width={SkeletonLoadingConfig.width} />);
    } else if (date) {
      setTextElement(<GenDate date={text} noTime={noTime} />);
    } else if (!date) {
      setTextElement(text);
    }
  }, [date, text, noTime]);
  return textElement || textElement === 0 ? (
    <StyledBox>
      <Grid
        container
        alignItems={alignItems}
        className={direction === 'vertical' ? classes.vertical : ''}
      >
        <Hidden {...(direction !== 'vertical' ? { lgUp: true } : false)}>
          <Grid item>
            <Box>
              <Typography variant={labelVariant} color={labelColor}>
                {text || text === 0 ? label : textElement}
              </Typography>
            </Box>
          </Grid>
        </Hidden>
        <Grid item>
          <Box
            sx={textboxParams}
            className={
              direction === 'vertical' || !text
                ? classes.textBoxVertical
                : classes.textBox
            }
          >
            <Typography
              variant={textVariant}
              color={textColor}
              // Render as a <div> only when the value is itself an element (e.g. a
              // Chip), which cannot legally nest inside the default <p>. Plain
              // string/number values keep the <p>.
              component={
                !currency && React.isValidElement(textElement) ? 'div' : 'p'
              }
              {...props}
            >
              {currency ? <GenCurrency value={textElement} /> : textElement}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  ) : (
    <span></span>
  );
};

export default GenDataText;
